import { render, staticRenderFns } from "./CategoryInfo.vue?vue&type=template&id=331ce99e&"
import script from "./CategoryInfo.vue?vue&type=script&lang=js&"
export * from "./CategoryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports